import React from 'react';
import {
  availableLanguagesAtom,
  setLocale,
  useSelectedLanguage
} from '@/components/Dashboard/Common/Translate/atom';
import { flags, LangType } from '@/components/Common/ChainManager/Insert/Translate/countriesData';
import { Group, Select, SelectProps, Text } from '@mantine/core';
import { useAtom } from 'jotai';
import classes from './TranslationSelector.module.css';
import cx from 'classnames';

interface TranslationSelectorProps {
  basic?: boolean;
  autoHeight?: boolean;
}

const renderSelectOption: SelectProps['renderOption'] = ({ option }) => {
  const Flag = flags[option.value as LangType];
  return (
    <Group wrap="nowrap">
      <Flag w={24} radius={0} />
      <Text size="sm">{option.label}</Text>
    </Group>
  );
};
export const TranslationSelector = ({ basic = false, autoHeight }: TranslationSelectorProps) => {
  const selected = useSelectedLanguage() as LangType;
  const [languages] = useAtom(availableLanguagesAtom);

  const Flag = flags[selected];

  // Add the lang even if it does not exist:
  // const dataLanguages = [...languages, ...(languages.includes(selected) ? [] : [selected])];

  if (!languages.includes('IT')) {
    languages.unshift('IT');
  }

  return (
    <Select
      renderOption={renderSelectOption}
      styles={{
        input: {
          height: autoHeight ? undefined : 36
        },
        dropdown: {
          zIndex: 10006
        }
      }}
      className={cx({ [classes.transparent]: !basic }, classes.select)}
      data={languages}
      value={selected}
      leftSection={<Flag w={24} radius={0} />}
      onChange={(lang) => lang && setLocale(lang)}
      maxDropdownHeight={400}
    />
  );
};

export default TranslationSelector;
